interface Props {
  thumbnailImgUrl: string;
  title: string;
  link: string;
  totalCount: number;
}

const getEmailThumbnailLink = ({
  thumbnailImgUrl,
  title,
  link,
  totalCount,
}: Props) => {
  return `<body style="display:inline-block; text-align: left;">
    <div style="height: 32px;"></div>
    <div style="display: block;align-items: center;margin: 0 auto;padding: 32px 32px;gap: 32px;width: 352px; height: auto;background: #FFFFFF;border: 1px solid #E4E4E7;border-radius: 8px;">
        <img class="thumbnail" src=${thumbnailImgUrl} style="display:block;width: 320px;height: auto;margin:auto auto 16px auto;border-radius: 8px;">
        <h4 class="file-title" style="width: 100%; margin:0 auto 0 auto;text-algin: center;line-break: anywhere;line-height: 125%;font-size: 20px;font-weight: 600; text-align:center;">${title}</h4>
        <p class="file-description" style="width: 100%;text-align: center;line-break: anywhere;line-height: 125%;color: #b4b4b4;font-size: 14px;font-weight: 400;">총 ${totalCount}페이지</p>
      <a style="display:block;border-radius: 8px;text-decoration: none;margin: 16px auto auto auto;padding: 16px 32px;gap: 8px;width: fit-content;height: auto;background: #6287A9;border: none;font-size: 16px;color: #ffffff; text-align:center;" href=${link} target="_blank">
        첨부된 파일 확인하기
      </a>
    </div>
    <div class="email-margin" style="height: 32px;"></div>
  </body>`;
};

export default getEmailThumbnailLink;
